import { Mail, Phone, Linkedin, ArrowUpRight } from "lucide-react";
import { PROFILE } from "../data/content";
import { LineReveal } from "./motion/Reveal";

export const Contact = () => {
  const links = [
    { icon: Mail, label: PROFILE.email, href: `mailto:${PROFILE.email}`, id: "email" },
    { icon: Phone, label: PROFILE.phone, href: `tel:${PROFILE.phone}`, id: "phone" },
    { icon: Linkedin, label: "LinkedIn", href: PROFILE.linkedin, id: "linkedin" },
  ];

  return (
    <section id="contact" data-testid="contact-section" className="relative mx-auto max-w-[1400px] px-5 py-28 md:px-12 md:py-40">
      <div className="orb bg-violet" style={{ width: 460, height: 460, bottom: "0%", left: "10%", opacity: 0.15 }} />
      <div className="max-w-3xl">
        <span className="font-mono text-xs uppercase tracking-[0.3em] text-electric">(Contact)</span>
        <h2 className="mt-4 font-display text-4xl font-extrabold uppercase leading-[0.9] tracking-tighter sm:text-5xl md:text-6xl">
          <LineReveal lines={["Let's", "build", "something."]} className="text-glow-blue" />
        </h2>

        <p className="mt-8 max-w-xl font-body text-base font-light leading-relaxed text-white/60">
          Open to full-time and freelance work in 3D technical design, pattern making and licensed product development. Reach out through any of the channels below.
        </p>

        <div className="mt-12">
          {links.map((l) => (
            <a
              key={l.id}
              data-testid={`contact-${l.id}`}
              href={l.href}
              target={l.href.startsWith("http") ? "_blank" : undefined}
              rel="noopener noreferrer"
              className="group flex items-center justify-between border-t border-white/10 py-6 transition-colors hover:border-electric/50 last:border-b"
            >
              <span className="flex items-center gap-4 font-heading text-xl text-cream md:text-2xl">
                <l.icon size={22} className="text-white/40 transition-colors group-hover:text-electric" />
                {l.label}
              </span>
              <ArrowUpRight size={22} className="text-white/30 transition-all group-hover:translate-x-1 group-hover:-translate-y-1 group-hover:text-electric" />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};
